import { render, staticRenderFns } from "./openFile.vue?vue&type=template&id=83b920fe"
import script from "./openFile.vue?vue&type=script&lang=js"
export * from "./openFile.vue?vue&type=script&lang=js"
import style0 from "./openFile.vue?vue&type=style&index=0&id=83b920fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports